import Dropdown from '@luminopia/react-toolbox/lib/dropdown'
import * as React from 'react'
import {WrappedFieldProps} from 'redux-form'

export interface IOption {
  value?: string | number
  label: string
}

/**
 * Properties passed to the component, excluding properties sent by the redux-form Field.
 */
export interface IFieldProps {
  label?: string
  options: IOption[]
}

/**
 * All properties passed to the component, including those sent by the redux-form Field.
 */
export interface IProps extends IFieldProps, WrappedFieldProps<{}> {
  className?: string
  disabled?: boolean
}

export default class SelectField extends React.Component<IProps, {}> {
  public render(): React.ReactElement<{}> | null {
    if (!this.props.input) { return null }
    const error = this.props.meta.touched ? this.props.meta.error : undefined
    const disabled = !!(this.props.disabled || this.props.meta.submitting)

    return (
      <Dropdown
        className={this.props.className}
        onChange={this.props.input.onChange}
        // NOTE Seems like there's a bug with @luminopia/react-toolbox's implementation of onBlur and onFocus
        // so that doesn't work exactly right.
        // https://github.com/@luminopia/react-toolbox/@luminopia/react-toolbox/issues/1354
        onBlur={this.props.input.onBlur}
        onFocus={this.props.input.onFocus}
        value={this.props.input.value}
        source={this.props.options}
        label={this.props.label}
        disabled={disabled}
        error={error}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/form/select-field.tsx